// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/CreateEvent/PriceVOD/PriceVOD.css
// module id = 1618
// module chunks = 0